var FakeCation = FakeCation || {};

(function (ns) {
  "use strict";

  // moore neightbour algorithm
  // usage:
  // var m = new MooreNeighbour([1, 3]);
  // var pos = m.next(function(x, y) {
  //    return point_inside_contouned_area();
  // });
  // pos => [2, 3]
  function MooreNeighbour(start_point) {
    //clockwise order
    var positions = [
      [0, 1],
      [-1, 1],
      [-1, 0],
      [-1, -1],
      [0, -1],
      [1, -1],
      [1, 0],
      [1, 1]
    ];

    var x = start_point[0];
    var y = start_point[1];
    var old_cell = [x, y + 1];

    // based on diff return the next position clockwise
    function clockwise_next(diff) {
      for (var i = 0; i < 8; ++i) {
        var d = positions[i];
        if (d[0] === diff[0] && d[1] === diff[1]) {
          return positions[(i + 1) % 8];
        }
      }
    }

    // with current cell and old_cell return new cell to test
    function next_cell(cell, old_cell) {
      var dx = cell[0] - old_cell[0];
      var dy = cell[1] - old_cell[1];
      var i = clockwise_next([-dx, -dy]);
      return [cell[0] + i[0], cell[1] + i[1]];
    }

    // return next contour cell, undefined if no new cell
    this.next = function (inside) {
      var c = 8; // max 8 positions to test
      while (c--) {
        var n = next_cell([x, y], old_cell);
        if (inside(n[0], n[1])) {
          //console.log("curr", [x, y], "to", n, "old", old_cell);
          x = n[0];
          y = n[1];
          return [x, y];
        }
        old_cell = n;
      }
    };
  }

  /**
      this function finds contour for a bunch of pixel given
      color of an image.
      Uses the Moore-Neighbor Tracing.
      Returns poligon whitout any processing
      usage:
          var poly = countour(ctx_imagedata.data, ctx.with, ctx.height, pointx, pointy)
  */
  function contour(image_data, width, height, x, y) {

    var components = 4; //rgba

    // get color to match
    var pixel_pos = (y * width + x) * components;
    var color = [image_data[pixel_pos],
      image_data[pixel_pos + 1],
      image_data[pixel_pos + 2]
    ];

    // helper
    function match_color(x, y) {
      if (x < 0 || x >= width || y < 0 || y >= height) {
        return false;
      }

      var pixel_pos = (y * width + x) * components;
      return color[0] === image_data[pixel_pos] &&
        color[1] === image_data[pixel_pos + 1] &&
        color[2] === image_data[pixel_pos + 2];
    }

    var poly = [];

    // first find the starting point
    var lower_y = y;
    var dummyForLint = 0;
    while (match_color(x, ++lower_y)) {
      dummyForLint++;
    }
    --lower_y;
    var start_point = [x, lower_y];

    // start with moore-neightbor
    var moore = new MooreNeighbour(start_point);
    var point;
    do {
      point = moore.next(match_color);
      poly.push(point);
    } while (!(start_point[0] === point[0] && start_point[1] === point[1]) && point !== undefined);
    return poly;
  }

  function createMask(imgData, width, height) {
    var x, y, offset, w = imgData.width || width,
      h = imgData.height || height,
      data = imgData.length ? imgData : imgData.data;

    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        offset = (y * w + x) * 4;
        if (data[offset + 3] > 0) {
          data[offset] = 255;
          data[offset + 1] = 0;
          data[offset + 2] = 0;
          data[offset + 3] = 255;
        } else {
          data[offset] = 0;
          data[offset + 1] = 255;
          data[offset + 2] = 0;
          data[offset + 3] = 255;
        }
      }
    }
  }

  function tracer(imgData, cx, cy, width, height) {
    var result;

    result = contour(imgData.length ? imgData : imgData.data, imgData.width || width, imgData.height || height, parseInt(cx, 10), parseInt(cy, 10));

    return result;
  }

  function draw_poly(ctx, poly, color, width) {
    ctx.strokeStyle = color || "rgb(255, 0, 128)";
    ctx.lineWidth = width || 1;
    ctx.beginPath();
    var p = poly[0];
    ctx.moveTo(p[0], p[1]);
    for (var i = 1; i < poly.length; ++i) {
      p = poly[i];
      ctx.lineTo(p[0], p[1]);
    }
    ctx.closePath();
    ctx.stroke();
  }

  function contract(poly, scale, ctx) {
    var middleX, middleY,
      bounding = {
        top: Infinity,
        left: Infinity,
        right: 0,
        bottom: 0
      };

    poly.forEach(function (p) {
      var x = p[0],
        y = p[1];

      if (y < bounding.top) {
        bounding.top = y;
      }
      if (y > bounding.bottom) {
        bounding.bottom = y;
      }

      if (x < bounding.left) {
        bounding.left = x;
      }

      if (x > bounding.right) {
        bounding.right = x;
      }
    });

    middleX = parseInt(bounding.left + (bounding.right - bounding.left) / 2, 10);
    middleY = parseInt(bounding.top + (bounding.bottom - bounding.top) / 2, 10);

    if (ctx) {
      ctx.strokeStyle = "yellow";
      ctx.rect(bounding.left, bounding.top, bounding.right - bounding.left, bounding.bottom - bounding.top);

      ctx.rect(middleX - 5, middleY - 5, 10, 10);
      ctx.stroke();

    }

    return poly.map(function (p) {
      var x = p[0],
        y = p[1];

      return [(x - middleX) * scale + middleX, (y - middleY) * scale + middleY];
    });
  }

  function greenboxOnPixels(imgData, pointArray, references, stops) {
    var points = [],
      refColors = references || [FakeCation.colorUtils.getColor(imgData, 100, 100)],
      blank = new FakeCation.colorUtils.Color(255, 0, 0, 0),
      stopColors = stops || false,
      isStopColor,
      counter = 0;

    function checkSimilar(refColor) {
      return refColor.similarHsl(this);
    }

    (pointArray || []).forEach(function (point) {
      var l = point[0] - 2,
        t = point[0] - 2,
        r = l + 5,
        b = t + 5,
        i, o;

      l = l < 0 ? 0 : l;
      t = t < 0 ? 0 : t;
      b = b > imgData.height ? imgData.height : b;
      r = r > imgData.width ? imgData.width : r;

      for (i = l; i < r; i++) {
        for (o = t; o < b; o++) {
          points.push([i, o]);
        }
      }
    });

    points.forEach(function (point) {
      var x = point[0],
        y = point[1],
        currentColor,
        isSimilarToRefcolors = false;

      isStopColor = stopColors !== false;
      currentColor = FakeCation.colorUtils.getColor(imgData, x, y);

      if (isStopColor) {
        isStopColor = stopColors.some(checkSimilar, currentColor);
      }

      if (!isStopColor) {
        isSimilarToRefcolors = refColors.some(checkSimilar, currentColor);
      }

      if (isSimilarToRefcolors) {
        FakeCation.colorUtils.setColor(imgData, x, y, blank);
        counter++;
      }

    });
    return counter;
  }

  function traceCountours(imageData, cx, cy, iteration, references, stops) {
    var currentIteration = 0,
      removedPixels,
      width = imageData.width,
      height = imageData.height;

    function iter() {
      console.log('traceCountours iteration:' + currentIteration + '/' + iteration);
      let mask = new Uint8ClampedArray(imageData.data);
      createMask(mask, width, height);
      let poly = contour(mask, width, height, parseInt(cx, 10), parseInt(cy, 10));

      poly.forEach(function (point) {
        var x = point[0],
          y = point[1];
        var offset = (y * width + x) * 4;
        mask[offset] = 0;
        mask[offset + 1] = 0;
        mask[offset + 2] = 255;
        mask[offset + 3] = 255;

      });

      FakeCation.utils.dump(mask);

      removedPixels = greenboxOnPixels(imageData, poly, references, stops);
      currentIteration++;
      console.log('removedPixels: ' + removedPixels);
      if (currentIteration < iteration) {
        window.requestAnimationFrame(iter);
      }
    }

    window.requestAnimationFrame(iter);

  }

  ns.tracer = tracer;
  ns.draw_contour = draw_poly;
  ns.contract = contract;
  ns.createMask = createMask;
  ns.greenboxOnPixels = greenboxOnPixels;
  ns.traceContours = traceCountours;

}(FakeCation));
